import { useMutation } from "@tanstack/react-query";
import api from "apis";

const useCompaniesMutation = () => {
  return useMutation({
    mutationFn: api.tag.manageCompanies,
  });
};

export default useCompaniesMutation;
